// extracted by mini-css-extract-plugin
export var actionButton = "_ma-0";
export var fileInput = "_ma-2";
export var paperclip = "_ma-1";